import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';
import { EmptyCollection } from '@components/main-components/media/illustrations/EmptyCollection';
import { CtaWrapper } from '../styles';

const HEADER_COPY = "It's a bit quiet in here";
const SUBHEADER_COPY = 'There are no releases yet.';

const ExploreButton = styled(Button, {
  marginTop: 16,
  paddingX: 12,
});

export const EmptyMyCollection = ({ isOwner }: { isOwner: boolean }) => {
  return (
    <EmptyStateCtaWrapper>
      <EmptyCollection />
      <h3>{HEADER_COPY}</h3>
      <p>{SUBHEADER_COPY}</p>
      {isOwner && <ExploreButton variant="primary" size="M" href="/feed" label="Explore Sounds" />}
    </EmptyStateCtaWrapper>
  );
};

const EmptyStateCtaWrapper = styled(CtaWrapper, {
  paddingBottom: 28,
  h3: {
    title: 'M',
    fontWeight: 500,
  },
  p: {
    base: 'M',
    color: '$neutral600',
    marginTop: 8,
  },
});
